import axios from 'axios';
import { sessionId } from './App';

const baseURL = "https://wallmuse.com:8443/wallmuse/ws";

export const getCategories = async () => {
  const response = await axios.get(`${baseURL}/get_categories`, {
    headers: {
      Accept: 'text/x-json',
    },
    params: {
      version: 1,
      session: sessionId
    },
  });

  return response.data["categorys"] ? response.data["categorys"] : [];
}

export const countArtworks = async (term, keywords, author, categories) => {
  term = cleanupEmptyParam(term);
  keywords = cleanupEmptyParam(keywords);
  author = cleanupEmptyParam(author);
  categories = cleanupEmptyParam(categories);
  const response = await axios.get(`${baseURL}/search_artworks_count`, {
    headers: {
      Accept: 'text/x-json',
    },
    params: {
      version: 1,
      desc: term,
      keywords: keywords,
      sauthor: author,
      categories: categories,
      session: sessionId
    },
  });

  return response.data["count"] ? parseInt(response.data["count"]) : 0;
}

export const searchArtworks = async (term, keywords, author, categories, page, size, sort) => {
  term = cleanupEmptyParam(term);
  keywords = cleanupEmptyParam(keywords);
  author = cleanupEmptyParam(author);
  categories = cleanupEmptyParam(categories);
  const response = await axios.get(`${baseURL}/search_artworks`, {
    headers: {
      Accept: 'text/x-json',
    },
    params: {
      version: 1,
      desc: term,
      keywords: keywords,
      sauthor: author,
      categories: categories,
      page: page,
      page_size: size,
      sort: sort,
      session: sessionId,
    },
  });

  return typeof response.data.artworks === 'undefined' ? [] : response.data.artworks;
};

export const countMontages = async (term, keywords, author, categories) => {
  term = cleanupEmptyParam(term);
  keywords = cleanupEmptyParam(keywords);
  author = cleanupEmptyParam(author);
  categories = cleanupEmptyParam(categories);
  const response = await axios.get(`${baseURL}/search_montages_count`, {
    headers: {
      Accept: 'text/x-json',
    },
    params: {
      version: 1,
      desc: term,
      keywords: keywords,
      sauthor: author,
      categories: categories,
      session: sessionId
    },
  });

  return response.data["count"] ? parseInt(response.data["count"]) : 0;
}

export const searchMontages = async (term, keywords, author, categories, page, size) => {
  term = cleanupEmptyParam(term);
  keywords = cleanupEmptyParam(keywords);
  author = cleanupEmptyParam(author);
  categories = cleanupEmptyParam(categories);
  const response = await axios.get(`${baseURL}/search_montages_full`, {
    headers: {
      Accept: 'text/x-json',
    },
    params: {
      version: 1,
      session: sessionId,
      page: page,
      page_size: size,
      desc: term,
      keywords: keywords,
      sauthor: author,
      categories: categories
    },
  });

  return typeof response.data.montages === 'undefined' ? [] : response.data.montages;
};

export const getMontageFull = async (montageId) => {
  const response = await axios.get(`${baseURL}/get_montage_full`, {
    headers: {
      Accept: 'text/x-json',
    },
    params: {
      version: 1,
      session: sessionId,
      montage: montageId
    },
  });

  return response.data;
};

export const getAllMontagesFull = async (page, size) => {
  const response = await axios.get(`${baseURL}/get_all_montages_full`, {
    headers: {
      Accept: 'text/x-json',
    },
    params: {
      version: 1,
      session: sessionId,
      page: page,
      page_size: size,
    },
  });

  return typeof response.data.montages === 'undefined' ? [] : response.data.montages;
}

export const saveMontages = async (montage) => {
  const payload = `montage=${JSON.stringify(montage)}`;
  const response = await axios.post(`${baseURL}/set_montage_full?version=1&session=${sessionId}`,
    payload, {
    headers: {
      Accept: 'text/x-json',
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' //added charset=UTF-8
    },
  });

  return response;

}
export const deleteMontage = async (userId, montageId) => {
  const response = await axios.post(`${baseURL}/del_montage?user=${userId}&montage=${montageId}&version=1&session=${sessionId}`,
    "", {
    headers: {
      Accept: 'text/x-json',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });

  return response;
}

export const getUser = async () => {
  const response = await axios.get(`${baseURL}/get_joomla_user`, {
    headers: {
      Accept: 'text/x-json',
    },
    params: {
      version: 1,
      session: sessionId
    },
  });
}

export const deleteArtwork = async (artworkId) => {
  try {
    const response = await axios.get(`${baseURL}/del_artwork`, {
      headers: {
        Accept: 'text/x-json',
      },
      params: {
        version: 1,
        session: sessionId,
        artwork: artworkId,
      },
    });

    return response.data; // Return the server's response
  } catch (error) {
    console.error('Error deleting artwork:', error);
    throw error; // Rethrow error to handle it in the calling function
  }
};

export const getArtworkById = async (artworkId) => {
  try {
    console.log('Fetching artwork with ID:', artworkId);

    const payload = new URLSearchParams();
    payload.append('version', 1);
    payload.append('artwork', artworkId);
    payload.append('session', sessionId);

    const response = await axios.post(`${baseURL}/search_artworks`, payload, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    });

    console.log('Received response:', response.data);

    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(response.data, 'application/xml');
    const artworks = xmlDoc.getElementsByTagName('artwork');

    console.log('Parsed artworks:', artworks);

    for (let i = 0; i < artworks.length; i++) {
      if (artworks[i].getAttribute('id') === artworkId.toString()) {
        console.log('Found matching artwork:', artworks[i]);
        return parseArtwork(artworks[i]);
      }
    }

    console.warn(`Artwork with ID ${artworkId} not found.`);
    return null;

  } catch (error) {
    console.error('Error fetching artwork:', error);
    throw error;
  }
};

// Function to parse the artwork XML element and return a structured JavaScript object
const parseArtwork = (artworkElement) => {
  try {
    return {
      id: artworkElement.getAttribute('id'),
      title: artworkElement.getAttribute('title'),
      displayTitle: artworkElement.getAttribute('display_title'),
      type: artworkElement.getAttribute('type'),
      publicSD: artworkElement.getAttribute('public_sd'),
      domain: artworkElement.getAttribute('domain'),
      datationStart: artworkElement.getAttribute('datation_start'),
      datationEnd: artworkElement.getAttribute('datation_end'),
      datationKind: artworkElement.getAttribute('datation_kind'),
      datationHidden: artworkElement.getAttribute('datation_hidden'),
      keywords: artworkElement.getAttribute('keywords'),
      streaming: artworkElement.getAttribute('streaming'),
      splittable: artworkElement.getAttribute('splittable'),
      croppable: artworkElement.getAttribute('croppable'),
      deconstructable: artworkElement.getAttribute('deconstructable'),
      bestTitle: artworkElement.getAttribute('best_title'),
      bestDescription: artworkElement.getAttribute('best_description'),
    };
  } catch (error) {
    console.error('Error parsing artwork:', error);
    throw error;
  }
};

// Helper function to get artwork URLs based on kind
const getArtworkURL = (artwork, kind) => {
  const urlElement = Array.from(artwork.getElementsByTagName('url')).find(url => url.getAttribute('kind') === kind);
  return urlElement ? urlElement.getAttribute('url') : '';
};

export async function searchCopyrightOwner(session, name) {
  const formData = new URLSearchParams();
  formData.append('version', '1');
  formData.append('session', session);
  formData.append('name', name);
  formData.append('kind', 'AUT');  // Kind is set to 'AUT' for author

  try {
    const response = await axios.post('https://wallmuse.com:8443/wallmuse/ws/search_copyright_owner', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(response.data, 'text/xml');
    const copyrightOwners = xmlDoc.getElementsByTagName('copyright_owner');
    const owners = [];

    for (let i = 0; i < copyrightOwners.length; i++) {
      const owner = {
        id: copyrightOwners[i].getAttribute('id'),
        displayName: copyrightOwners[i].getAttribute('display_name'),
      };
      owners.push(owner);
    }

    return owners; // Returns the list of copyright owners

  } catch (error) {
    console.error('Error searching copyright owner:', error);
    throw error;
  }
}

const cleanupEmptyParam = param => !param || param.trim().length === 0 ? null : param

// #%RAML 1.0
// title: Wallmuse API
// baseUri: https://wallmuse.com:8443/wallmuse/ws

// types:
//   Category:
//     type: object
//     properties:
//       id: integer
//       name: string
//   Artwork:
//     type: object
//     properties:
//       id: integer
//       title: string
//       author: string
//       keywords: string
//       categories: Category[]
//   Montage:
//     type: object
//     properties:
//       id: integer
//       title: string
//       author: string
//       keywords: string
//       categories: Category[]
//       artworks: Artwork[]

// /categories:
//   get:
//     description: Get all categories
//     responses:
//       200:
//         body:
//           application/json:
//             type: Category[]
// /artworks:
//   get:
//     description: Search for artworks
//     queryParameters:
//       term: string
//       keywords: string
//       author: string
//       categories: string
//       page: integer
//       size: integer
//     responses:
//       200:
//         body:
//           application/json:
//             type: Artwork[]
// /artworks/count:
//   get:
//     description: Get the count of artworks for a search
//     queryParameters:
//       term: string
//       keywords: string
//       author: string
//       categories: string
//     responses:
//       200:
//         body:
//           application/json:
//             properties:
//               count: integer
// /montages:
//   get:
//     description: Search for montages
//     queryParameters:
//       term: string
//       keywords: string
//       author: string
//       categories: string
//       page: integer
//       size: integer
//     responses:
//       200:
//         body:
//           application/json:
//             type: Montage[]
//   post:
//     description: Save a montage
//     body:
//       application/x-www-form-urlencoded:
//         properties:
//           montage: Montage
//     responses:
//       200:
//         body:
//           application/json:
//             properties:
//               status: string
// /montages/{montageId}:
//   get:
//     description: Get a full montage
//     responses:
//       200:
//         body:
//           application/json:
//             type: Montage
//   delete:
//     description: Delete a montage
//     responses:
//       200:
//         body:
//           application/json:
//             properties:
//               status: string
// /montages/count:
//   get:
//     description: Get the count of montages for a search
//     queryParameters:
//       term: string
//       keywords: string
//       author: string
//       categories: string
//     responses:
//       200:
//         body:
//           application/json:
//             properties:
//               count: integer
// /user:
//   get:
//     description: Get the current user
//     responses:
//       200:
//         body:
//           application/json:
//             properties:
//               id: integer
//               username: string
//               email: string